import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'gob-stars',
  templateUrl: './stars.component.html',
  styleUrls: ['./stars.component.css']
})
export class StarsComponent implements OnInit {
  _stars: number;
  @Input()
  set stars(val: number){
    const numericVal = Number(val);
    this._stars = Number.isFinite(numericVal) ? Math.max(0, Math.floor(numericVal)) : 0;
  };

  get stars(){
    return this._stars;
  }

  constructor() {
    this.stars=0;
  }

  ngOnInit(): void {
  }

  /**
   * Return an array of length equal to the number of full stars (max 5)
   * @returns {any[]}
   */
  get fullStars(): any[] {
    return Array(Math.min(this._stars, 5));
  }

  /**
   * Return an array of length equal to the number of empty stars needed to reach 5.
   * Ensures the length is not negative.
   * @returns {any[]}
   */
  get emptyStars(): any[] {
    return Array(Math.max(5 - this._stars, 0));
  }

}
